import { render, staticRenderFns } from "./PlaylistsPersonal.vue?vue&type=template&id=68ef9f1a&scoped=true"
import script from "./PlaylistsPersonal.vue?vue&type=script&lang=js"
export * from "./PlaylistsPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef9f1a",
  null
  
)

export default component.exports